<div class="h-100 overflow-auto crm-scroll" [formGroup]="formPacket">
  <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white position-sticky top-0 z-5">
    <h4 class="m-0 text-crm">{{ 'buy_package' | translate }}</h4>
    @if (balance) {
      <div class="d-flex flex-column text-black fs-sm">
        <div>{{ 'your_account_information' | translate }}: {{ balance?.sum }} {{ 'UAH' | translate }}.</div>
        <div>{{ 'available_balance' | translate }}: {{ balance?.bonus }} {{ 'bonuses' | translate }}</div>
      </div>
    }
    @if (baseService.isMobile) {
      <app-button [btnType]="'icon'" matTooltip="{{ 'close' | translate }}" (onChangeClick)="closeBar()">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>

  <mat-divider class="my-2"></mat-divider>

  <!--  <div *ngIf="!packetsAll.length" class="d-flex flex-column gap-3 px-4 py-2">-->
  <!--    <div-->
  <!--      class="cursor-pointer"-->
  <!--      *ngFor="let category of categories"-->
  <!--      (click)="selectCategory(category)"-->
  <!--    >-->
  <!--      {{ category.name }}-->
  <!--    </div>-->
  <!--  </div>-->
  <div class="d-flex">
    <div class="m-2 d-flex justify-content-center flex-wrap gap-3 w-100">
      @for (category of categories; track category; let i = $index) {
        <app-dropdown
          class="category"
          [items]="category"
          (onValueChange)="selectCategory($event, i)"
          [closeOnSelect]="true"
          [ngModel]="null"
          [placeholder]="'your_category' | translate"
          [disabled]="isLoader"
          formControlName="currentPacket"
        ></app-dropdown>
      }
      @if (zones.length) {
        <div>
          <app-dropdown
            bindLabel="label_ua"
            bindLabelOption="label_ua"
            [items]="zones"
            (onValueChange)="selectZone($event)"
            [closeOnSelect]="true"
            [placeholder]="'your_region' | translate"
            formControlName="zone"
            [isTranslate]="false"
            [disabled]="isLoader"
          >
          </app-dropdown>
        </div>
      }

      @if (currentZone && isCurrentZone) {
        <div>
          <app-dropdown
            bindLabelOption="label_ua"
            [items]="currentZone"
            (onValueChange)="selectCurrentZone($event)"
            [closeOnSelect]="true"
            [placeholder]="'your_zone' | translate"
            formControlName="currentZone"
          >
            [disabled]="isLoader"
          </app-dropdown>
        </div>
      }
    </div>
  </div>

  @if (notFound) {
    <div class="d-flex justify-content-center">
      <span>{{ 'not_found_packet' | translate }}</span>
    </div>
  }

  @if (isLoader) {
    <div class="d-flex justify-content-center">
      <app-loader size="small"></app-loader>
    </div>
  } @else {
    @if (isPacket) {
      <div class="d-flex justify-content-center flex-wrap gap-5 mt-3">
        @if (isBase) {
          <div class="packet-wrapper">
            <div class="container packet-container d-flex flex-column justify-content-around">
              <div class="d-flex justify-content-between gap-2 align-items-center">
                <div>
                  <h5>Старт</h5>
                </div>
                <div>
                  <app-dropdown
                    [items]="packets.base.packages"
                    (onValueChange)="packetBase($event)"
                    [placeholder]="'count_adverts' | translate"
                    formControlName="countAdverts"
                    [closeOnSelect]="true"
                  ></app-dropdown>
                </div>
              </div>
              <div class="packet-info">
                <div>
                  <h3>{{ selectedBase?.price || 0 }}грн</h3>
                </div>
                <div class="d-flex w-100 d-flex justify-content-between">
                  <div>
                    @if (!this.planned_at_base) {
                      <app-button
                        [disabled]="!selectedBase"
                        (onChangeClick)="choosePacket($event, selectedBase)"
                        class="w-100"
                        >{{ 'buy' | translate }}
                      </app-button>
                    }
                    @if (this.planned_at_base && selectedBase) {
                      <app-button
                        [disabled]="!selectedBase"
                        (onChangeClick)="choosePacket($event, selectedBase)"
                        class="w-100"
                        >{{ 'plan_packet' | translate }}
                      </app-button>
                    }
                  </div>
                  <div>
                    @if (planned_at_base) {
                      <app-button
                        btnType="icon"
                        [disabled]="!selectedBase"
                        (onChangeClick)="cancelPlanner(selectedBase)"
                        [matTooltip]="'cancel' | translate"
                      >
                        <app-icon>event_busy</app-icon>
                      </app-button>
                    }
                    @if (!planned_at_base) {
                      <app-button btnType="icon" (onChangeClick)="openPlanner(selectedBase)">
                        <app-icon>calendar_month</app-icon>
                      </app-button>
                    }
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex flex-column">
                  <h4>Що включено</h4>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>Бізнес-сторінка</span>
                  </div>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>Пакет дійсний 30 днів</span>
                  </div>
                  <div><br /></div>
                  <div><br /></div>
                  <div><br /></div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (isPremium) {
          <div class="packet-wrapper">
            <div class="container packet-container d-flex flex-column justify-content-around">
              <div class="d-flex justify-content-between gap-2 align-items-center">
                <div>
                  <h5>Преміум</h5>
                </div>
                <div>
                  <app-dropdown
                    [items]="packets.premium.packages"
                    (onValueChange)="packetPremium($event)"
                    [placeholder]="'count_adverts' | translate"
                    formControlName="countAdverts"
                    [closeOnSelect]="true"
                  ></app-dropdown>
                </div>
              </div>
              <div class="packet-info">
                <div>
                  <h3>{{ selectedPremium?.price || 0 }}грн</h3>
                </div>
                <div class="d-flex w-100 d-flex justify-content-between">
                  @if (!this.planned_at_premium) {
                    <app-button
                      [disabled]="!selectedPremium"
                      (onChangeClick)="choosePacket($event, selectedPremium)"
                      class="w-100"
                      >{{ 'buy' | translate }}
                    </app-button>
                  }
                  @if (this.planned_at_premium && selectedPremium) {
                    <app-button
                      [disabled]="!selectedPremium"
                      (onChangeClick)="choosePacket($event, selectedPremium)"
                      class="w-100"
                      >{{ 'plan_packet' | translate }}
                    </app-button>
                  }
                  <div>
                    @if (planned_at_premium) {
                      <app-button
                        btnType="icon"
                        [disabled]="!selectedPremium"
                        (onChangeClick)="cancelPlanner(selectedPremium)"
                        [matTooltip]="'cancel' | translate"
                      >
                        <app-icon>event_busy</app-icon>
                      </app-button>
                    }
                    @if (!planned_at_premium) {
                      <app-button btnType="icon" (onChangeClick)="openPlanner(selectedPremium)">
                        <app-icon>calendar_month</app-icon>
                      </app-button>
                    }
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex flex-column">
                  <h4>Що включено</h4>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>3 х Підняття кожного оголошення</span>
                  </div>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>Персональний дизайн сторінок оголошень</span>
                  </div>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>Оновлена бізнес-сторінка</span>
                  </div>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>Пакет дійсний 30 днів</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (isMega) {
          <div class="packet-wrapper">
            <div class="container packet-container d-flex flex-column justify-content-around">
              <div class="d-flex justify-content-between gap-2 align-items-center">
                <div>
                  <h5>Мега</h5>
                </div>
                <div>
                  <app-dropdown
                    [items]="packets.mega.packages"
                    (onValueChange)="packetMega($event)"
                    [placeholder]="'count_adverts' | translate"
                    formControlName="countAdverts"
                    [closeOnSelect]="true"
                  ></app-dropdown>
                </div>
              </div>
              <div class="packet-info">
                <div>
                  <h3>{{ selectedMega?.price || 0 }}грн</h3>
                </div>
                <div class="d-flex w-100 d-flex justify-content-between">
                  <div>
                    @if (!this.planned_at_mega) {
                      <app-button
                        [disabled]="!selectedMega"
                        (onChangeClick)="choosePacket($event, selectedMega)"
                        class="w-100"
                        >{{ 'buy' | translate }}
                      </app-button>
                    }
                    @if (this.planned_at_mega && selectedMega) {
                      <app-button
                        [disabled]="!selectedMega"
                        (onChangeClick)="choosePacket($event, selectedMega)"
                        class="w-100"
                        >{{ 'plan_packet' | translate }}
                      </app-button>
                    }
                  </div>
                  <div>
                    @if (planned_at_mega) {
                      <app-button
                        btnType="icon"
                        [disabled]="!selectedMega"
                        (onChangeClick)="cancelPlanner(selectedMega)"
                        [matTooltip]="'cancel' | translate"
                      >
                        <app-icon>event_busy</app-icon>
                      </app-button>
                    }
                    @if (!planned_at_mega) {
                      <app-button btnType="icon" (onChangeClick)="openPlanner(selectedMega)">
                        <app-icon>calendar_month</app-icon>
                      </app-button>
                    }
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex flex-column">
                  <h4>Що включено</h4>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>3 х Підняття кожного оголошення</span>
                  </div>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>Персональний дизайн сторінок оголошень</span>
                  </div>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>Оновлена бізнес-сторінка</span>
                  </div>
                  <div class="d-flex gap-2">
                    <app-icon class="info-icon">check</app-icon>
                    <span>Пакет дійсний 30 днів</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
